module.exports = __webpack_public_path__ + "static/media/image-card-8.7d4af506.png";